import { useMemo } from "react";
import { getSculpturesInRange } from "./getSculpturesInRange";

export const useNearbySculptures = (userLocation, sculptures) => {
  return useMemo(
    () => getSculpturesInRange(userLocation, sculptures),
    [userLocation, sculptures]
  );
};
